import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default class FaqtsLocationDisplay extends React.Component {
    render() {
        const { location, compact } = this.props;

        if (!location) {
            return <div>No Location Data</div>;
        }

        return (
            <div className="d-flex">
                <div className="mr-1">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                </div>

                <div>
                    <div>{location.address1}</div>

                    {!compact && (
                        <>
                            {location.address2 && (
                                <div>{location.address2}</div>
                            )}

                            <div>
                                {location.city}, {location.state} {location.zip}
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}
